module.exports = __webpack_public_path__ + "img/icono-18-2.7885f653.png";